module.exports = __webpack_public_path__ + "img/transparent_square.01f6c838.svg";